export { default } from './TableRecordName';
